import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-why-us',
  templateUrl: './why-us.component.html',
  styleUrls: ['./why-us.component.less']
})
export class WhyUsComponent implements OnInit {
  appLogo: string;
  appheader: string;
  navbarOpen = false;
  constructor(private router: Router) {
    this.appLogo = '../../assets/images/akrti copy.png';
  }

  ngOnInit() {
  }
  toggleNavbar() {
    this.navbarOpen = !this.navbarOpen;
  }
}
